import { useNavigate } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Screen } from '@/app/layout/Screen';
import { Button } from '@/components/ui/Button';
import { StateView } from '@/components/ui/Feedback';

/** Неизвестный маршрут: возможен при переходе по устаревшей ссылке из чата. */
export function NotFoundScreen() {
  const navigate = useNavigate();

  return (
    <Screen subtitle="Страница не найдена" back backTo="/home">
      <StateView
        icon={<Compass className="h-6 w-6" aria-hidden />}
        title="Страница не найдена"
        description="Возможно, ссылка устарела или относится к другому профилю."
        primary={
          <Button variant="primary" block onClick={() => navigate('/home', { replace: true })}>
            На главную
          </Button>
        }
        secondary={
          <Button variant="ghost" block onClick={() => navigate('/help')}>
            Написать в поддержку
          </Button>
        }
      />
    </Screen>
  );
}
